import { BaseMapper } from '@ps/utils';
import { FeasibilityResult } from '@ps/survey-utils';
import { FeasibilityResponseDto } from '../dtos/feasibility.dto';

export class FeasibilityMapper extends BaseMapper<
  FeasibilityResponseDto,
  FeasibilityResult
> {
  public fromDto(dto: FeasibilityResponseDto): FeasibilityResult {
    return {
      quotas: dto.quotas.map((quota) => ({
        buyerQuotaId: quota.buyer_quota_id,
        count: quota.count,
      })),
      totalFeasibility: dto.total_feasibility,
      feasibilityCpi: dto.feasibility_cpi,
      suppliers: (dto.suppliers ?? []).map((supplier) => ({
        supplierId: supplier.supplier_id,
        count: supplier.count,
        cpi: supplier.cpi,
      })),
      unusedQualifications: dto.unused_qualifications ?? [],
      unusedCriteria: dto.unused_criterias ?? [],
      difficultQuotaIds: (dto.difficult_quotas ?? []).map(
        (quota) => quota.buyer_quota_id,
      ),
      currency: dto.currency_fx,
    };
  }
}
